import { useQuery } from 'react-query';

import { MindsightAuthSystemApi } from '../api/mindsightAuthSystem';

export interface UseHideLogoutSankhyaRhResult {
  hideLogoutSankhyaRh: boolean;
  isLoading: boolean;
}

export const useHideLogoutSankhyaRh = (authUrl: string): UseHideLogoutSankhyaRhResult => {
  const { data, isLoading } = useQuery(
    ['new_design_toggle'],
    () => MindsightAuthSystemApi.getNewDesignToggle(authUrl),
    {
      enabled: !!authUrl,
    }
  );

  const hideLogoutSankhyaRh = data?.t004_hide_logout_sankhyarh ?? false;

  return { hideLogoutSankhyaRh, isLoading };
};
